import React, { useState } from 'react';
import VideoUploader from './upload/VideoUploader';
import DubbingConfig from './upload/DubbingConfig';
import JobDashboard from './jobs/JobDashboard';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'upload' | 'jobs'>('upload');
  const [uploadedVideoPath, setUploadedVideoPath] = useState<string>('');
  const [uploadedVideoName, setUploadedVideoName] = useState<string>('');
  const [showConfig, setShowConfig] = useState(false);

  const handleUploadComplete = (filePath: string) => {
    setUploadedVideoPath(filePath);
    const fileName = filePath.split('/').pop() || 'video';
    setUploadedVideoName(fileName);
    setShowConfig(true);
    console.log('Video uploaded to:', filePath);
  };

  const handleJobCreated = (jobId: string) => {
    console.log('Job created:', jobId);
    // Reset upload state and switch to jobs tab
    setUploadedVideoPath('');
    setUploadedVideoName('');
    setShowConfig(false);
    setActiveTab('jobs');
  };

  const handleCancelConfig = () => {
    setShowConfig(false);
    setUploadedVideoPath('');
    setUploadedVideoName('');
  };

  return (
    <div className="dashboard">
      <div className="dashboard-container">
        <div className="tab-navigation">
          <button
            className={`tab-button ${activeTab === 'upload' ? 'active' : ''}`}
            onClick={() => setActiveTab('upload')}
          >
            📤 Upload Video
          </button>
          <button
            className={`tab-button ${activeTab === 'jobs' ? 'active' : ''}`}
            onClick={() => setActiveTab('jobs')}
          >
            📋 My Jobs
          </button>
        </div>

        <div className="tab-content">
          {activeTab === 'upload' ? (
            <div className="upload-section">
              {!showConfig ? (
                <>
                  <h2>Upload Video for Dubbing</h2>
                  <VideoUploader onUploadComplete={handleUploadComplete} />
                </>
              ) : (
                <DubbingConfig
                  videoPath={uploadedVideoPath}
                  videoName={uploadedVideoName}
                  onJobCreated={handleJobCreated}
                  onCancel={handleCancelConfig}
                />
              )}
            </div>
          ) : (
            <div className="jobs-section">
              <JobDashboard />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;